export const API_URL = process.env.REACT_APP_API_URL || "http://api.brandsek.com/api";

export const IMAGE_URL = "https://api.brandsek.com";

export const DEHASH_API_URL = "https://api.brandsek.com/api";
export const MEDIA_URL =
  process.env.REACT_APP_MEDIA_URL || "https://api.brandsek.com";

export const GOOGLE_MAPS_API =
  "https://maps.googleapis.com/maps/api/js?key=AIzaSyA6rzkm6pD8bXg_L5HpcJ3YSmbE1mKkWG8&v=3.exp&libraries=geometry,drawing,places";

export const GOOGLE_LOGIN_URL = process.env.REACT_APP_GOOGLE_URL || "https://auth.brandsek.com/realms/Brandsek/protocol/openid-connect/auth?client_id=Brandsek&redirect_uri=https://api.brandsek.com/api/google-login&response_type=code&scope=openid&kc_idp_hint=google";
export const MICROSOFT_LOGIN_URL = process.env.REACT_APP_MICROSOFT_URL || "https://auth.brandsek.com/realms/Brandsek/protocol/openid-connect/auth?client_id=Brandsek&redirect_uri=https://api.brandsek.com/api/google-login&response_type=code&scope=openid&kc_idp_hint=microsoft";
